import script from "./TournamentList.vue?vue&type=script&setup=true&lang=js"
export * from "./TournamentList.vue?vue&type=script&setup=true&lang=js"

import "./TournamentList.vue?vue&type=style&index=0&id=44e3992e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44e3992e"]])

export default __exports__